import {Badge} from 'react-bootstrap'
import {KTSVG} from '../../../helpers'
import {ReleaseNote} from './core/_models'

type Props = {
  handleClose: () => void | undefined
  releaseNote: ReleaseNote
}

export function ReleaseNoteModalContent({handleClose, releaseNote}: Props) {
  return (
    <>
      <div className='modal-header border-0' style={{maxWidth: '100%'}}>
        <div className='col-md-11'>
          <div className='d-flex'>
            <h2 className="fs-bold fs-1">{releaseNote.title}</h2>
            <div className="d-flex">
              {releaseNote.flags?.map((flag) => (
                <Badge key={flag} bg='success' className='ms-4 fs-7'>
                  {flag}
                </Badge>
              ))}
            </div>
          </div>
            {!!releaseNote.version && <span className='d-block ms-1 mt-1'>Versão: {releaseNote.version}</span>}
        </div>
        <div className='col-md-1 d-flex justify-content-end align-items-center'>
          <button
            className='btn btn-sm btn-icon btn-active-color-primary h-auto ms-4'
            onClick={handleClose}
          >
            <KTSVG
              className='svg-icon-2x svg-icon-gray-800'
              path='/media/icons/duotune/arrows/arr061.svg'
            />
          </button>
        </div>
      </div>
      <div className='modal-body pt-0' style={{maxWidth: '100%'}}>
        <div className='tab-content' style={{maxWidth: '100%'}}>
          <div
            className='tab-pane fade active show release-note'
            style={{maxWidth: '100%'}}
            id='kt_tab_pane_1'
            role='tabpanel'
            dangerouslySetInnerHTML={{__html: releaseNote.body}}
          ></div>
        </div>
      </div>
    </>
  )
}
